import { useState, useEffect } from "react";

// Detect user device type based on screen width + touch capability.
// Returns: { type: 'mobile'|'tablet'|'desktop', isTouch, isPortrait, isLandscape, width, height }
export const useDevice = () => {
  const get = () => {
    if (typeof window === "undefined") {
      return { type: "desktop", isTouch: false, isPortrait: false, isLandscape: true, width: 1920, height: 1080 };
    }
    const w = window.innerWidth;
    const h = window.innerHeight;
    const isTouch = ("ontouchstart" in window) || navigator.maxTouchPoints > 0;
    let type = "desktop";
    if (w < 640) type = "mobile";
    else if (w < 1180) type = "tablet"; // covers iPad Mini (768), iPad (810), iPad Pro 11" (1024-1180)
    return { type, isTouch, isPortrait: h > w, isLandscape: w >= h, width: w, height: h };
  };

  const [info, setInfo] = useState(get);

  useEffect(() => {
    const onResize = () => setInfo(get());
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  // Set body data attribute so CSS can target device types
  useEffect(() => {
    document.body.dataset.device = info.type;
    document.body.dataset.orientation = info.isPortrait ? "portrait" : "landscape";
    document.body.dataset.touch = info.isTouch ? "yes" : "no";
  }, [info.type, info.isPortrait, info.isTouch]);

  return info;
};

export default useDevice;
